import { ELEMENT_PARAGRAPH } from '@udecode/plate-paragraph';

export const PARAGRAPH_KEY = ELEMENT_PARAGRAPH;
export const PARAGRAPH_TYPE = 'paragraph';
